define('SuiteCommerce.OrderStatus.Utils',
  [
    'SuiteCommerce.OrderStatus.Configuration',
    'Handlebars',
    'underscore'
  ],
  function define(
    Configuration,
    Handlebars,
    _
  ) {
    'use strict';
    var CONFIGURATION_SUBTAB_ID = 'orderstatus';
    function getConfigurationParameter(parameter) {
      return Configuration.get(CONFIGURATION_SUBTAB_ID + '.' + parameter);
    }
    function registerHandlevarsHelpers() {
      Handlebars.registerHelper('equals', function registerHelper(value1, value2, conf) {
        if (value1 === value2) {
          return conf.fn(this);
        }
        return conf.inverse(this);
      });
      Handlebars.registerHelper('isgreaterthan', function registerHelper(value1, value2, conf) {
        if (value1 > value2) {
          return conf.fn(this);
        }
        return conf.inverse(this);
      });
      Handlebars.registerHelper('islessthan', function registerHelper(value1, value2, conf) {
        if (value1 < value2) {
          return conf.fn(this);
        }
        return conf.inverse(this);
      });
    }
    // eslint-disable-next-line complexity
    function formatCurrency(value, symbol, noDecimalPosition) {
      var valueFloat = parseFloat(value);
      var negative = valueFloat < 0;
      var groupSeparator = ',';
      var decimalSeparator = '.';
      var negativePrefix = '(';
      var negativeSuffix = ')';
      var thousandString = '';
      var beforeValue = true;
      var valueString;
      var decimalPosition;
      var i;
      var symbolWrapper = symbol;
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(valueFloat)) {
        return value;
      }
      valueFloat = parseInt('' + (Math.abs(valueFloat) + 0.005) * 100, 10) / 100;
      valueString = valueFloat.toString();
      groupSeparator = Configuration.getSiteSetting('groupseparator');
      decimalSeparator = Configuration.getSiteSetting('decimalseparator');
      negativePrefix =  Configuration.getSiteSetting('negativeprefix');
      negativeSuffix =  Configuration.getSiteSetting('negativesuffix');
      valueString = valueString.replace('.', decimalSeparator);
      decimalPosition = valueString.indexOf(decimalSeparator);
      // if the string doesn't contains a .
      if (decimalPosition === -1) {
        if (!noDecimalPosition) {
          valueString += decimalSeparator + '00';
        }
        decimalPosition = valueString.indexOf(decimalSeparator);
      } else if (valueString.indexOf(decimalSeparator) === (valueString.length - 2)) {
        // if it only contains one number after the .
        valueString += '0';
      }
      for (i = valueString.length - 1; i >= 0; i -= 1) {
        // If the distance to the left of the decimal separator is a multiple
        // of 3 you need to add the group separator
        thousandString = (i > 0 && i < decimalPosition && (((decimalPosition - i) % 3) === 0) ? groupSeparator : '')
          + valueString[i] + thousandString;
      }
      if (!symbolWrapper) {
        symbolWrapper = '$';
      }
      valueString = beforeValue || _.isUndefined(beforeValue) ? symbolWrapper + thousandString
        : thousandString + symbolWrapper;
      return negative ? (negativePrefix + valueString + negativeSuffix) : valueString;
    }
    return {
      getConfigurationParameter: getConfigurationParameter,
      formatCurrency: formatCurrency,
      registerHandlevarsHelpers: registerHandlevarsHelpers
    };
  });
